import Button from "./Button.vue"
import SubmitButton from "./SubmitButton.vue"
import BackButton from "./BackButton.vue"

export default {
    install(Vue) {
        Vue.component("BackButton", BackButton)
        Vue.component("SubmitButton", SubmitButton)
        Vue.component("Button", Button)
    },
}
